import { render, staticRenderFns } from "./TaskCommentLikeReply.vue?vue&type=template&id=45d3ea83&scoped=true&"
import script from "./TaskCommentLikeReply.vue?vue&type=script&lang=js&"
export * from "./TaskCommentLikeReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d3ea83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d3ea83')) {
      api.createRecord('45d3ea83', component.options)
    } else {
      api.reload('45d3ea83', component.options)
    }
    module.hot.accept("./TaskCommentLikeReply.vue?vue&type=template&id=45d3ea83&scoped=true&", function () {
      api.rerender('45d3ea83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/TaskCommentLikeReply.vue"
export default component.exports